import { Radio as WSRRadio } from '@wix/design-system'
import React, { FC, memo } from 'react'

import s from './Radio.scss'

type RadioProps = {
  checked: boolean
  value: string
  label: string
  onClick?: () => void
}

export const Radio: FC<RadioProps> = memo(({ checked, value, label, onClick }) => (
  <div className={`${s.radio} ${checked ? s.checked : ''}`} onClick={onClick}>
    <WSRRadio dataHook={`radio-${label}`} checked={checked} value={value} label={label} alignItems="top" />
  </div>
))
